import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SocialNavigation from '@components/Footer/SocialNavigation';
import EmailForm from '@components/Footer/EmailForm';
import LinkNavigation from '@components/Footer/LinkNavigation';
import ContactNavigation from '@components/Footer/ContactNavigation';
import IsoNavigation from '@components/Footer/IsoNavigation';
import DisclaimerFooter from '@components/Footer/DisclaimerFooter';
import Banner from '@components/Footer/Banner';
import templateDataService from '@/services/template-data-service';
import styles from './Footer.module.scss';

export const Footer = () => {
  const templateData = templateDataService.getTemplateData();

  return (
    <Container className={`${styles.footer} pb-1`}>
      <Banner />
      <Row className={`${styles.lint} flex-column mb-5 d-flex`}></Row>

      <Row className={styles.navigation}>
        <LinkNavigation templateData={templateData} />
        <Col lg={3}>
          <Row>
            <EmailForm />
            <SocialNavigation className="pt-3 pb-3" />
            <ContactNavigation className="pb-3" templateData={templateData} />
            <IsoNavigation className="pt-2" />
          </Row>
        </Col>
      </Row>

      <Row className={styles.disclaimer}>
        <DisclaimerFooter links={templateData.footer.footer} />
      </Row>
    </Container>
  );
};
